import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import RouterInfo from 'routes/root.jsx';
import store from './reducers/Store';
import { Provider } from 'react-redux';


const RouterObject = createBrowserRouter(RouterInfo);

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  //<React.StrictMode> ws. 23.11.21  Error - Muti Check Code. 
      <Provider store={store}>
        <RouterProvider router={RouterObject} />
      </Provider>

  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
